import { BookOpen } from "lucide-react";
import CourseCard from "../Course/CourseCard";
import { useCourses } from "../../apis/queries";
import { CardSkeleton, EmptyState, LinkButton, Section, SectionHeading, accent } from "../ui";

const PopularCourses = () => {
  const { data: fetchedCourses, isLoading, isError, error } = useCourses({ featured: true });

  const courses = fetchedCourses?.courses ?? [];
  const hasCourses = Array.isArray(courses) && courses.length > 0;

  return (
    <Section id="courses" tone="alt">
      <SectionHeading
        eyebrow="Courses"
        eyebrowAccent={accent('gold').rule}
        title="Popular Courses"
        description="Expand your knowledge with our top-rated courses taught by expert instructors from around the world"
        // Secondary so the only primary buttons in this band are the ones on the cards.
        action={<LinkButton to="/courses" variant="secondary">Browse all courses</LinkButton>}
      />

      {isLoading && (
        // `index` walks the skeletons through the accent palette, so the first
        // thing a visitor sees is a colourful grid rather than a wall of grey.
        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 xl:grid-cols-3 lg:gap-8">
          {[...Array(3)].map((_, index) => (
            <CardSkeleton key={index} index={index} />
          ))}
        </div>
      )}

      {isError && (
        <EmptyState
          tone="rose"
          icon={<BookOpen size={20} aria-hidden="true" />}
          title="Could not load popular courses"
          description={error?.message || "Please try again later."}
          action={
            <LinkButton to="/courses" variant="secondary">Browse all courses</LinkButton>
          }
        />
      )}

      {!isLoading && !isError && !hasCourses && (
        <EmptyState
          tone="gold"
          icon={<BookOpen size={20} aria-hidden="true" />}
          title="No popular courses available at the moment."
          description="Please check back later!"
          action={
            <LinkButton to="/courses" variant="secondary">Browse all courses</LinkButton>
          }
        />
      )}

      {!isLoading && !isError && hasCourses && (
        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 xl:grid-cols-3 lg:gap-8">
          {courses.map((course, index) => (
            <CourseCard key={course._id ?? index} course={course} enrollmentType="paid" />
          ))}
        </div>
      )}
    </Section>
  );
};

export default PopularCourses;
